import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const ChatLeads = Loadable(
  lazy(() =>
    import("./Chatleads").then(({ ChatLeads }) => ({
      default: ChatLeads,
    })),
  ),
);

const ManageChatLead = Loadable(
  lazy(() =>
    import("./ManageChatLead").then(({ ManageChatLead }) => ({
      default: ManageChatLead,
    })),
  ),
);

export const chatLeadRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.leads.chatLeads,

    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM]}>
        <ChatLeads />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${REACT_APP_NAV_ROUTES.leads.chatLeads}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM]}>
        <ManageChatLead />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${REACT_APP_NAV_ROUTES.leads.chatLeads}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM]}>
        <ManageChatLead />
      </AuthorizedRoute>
    ),
  },
  {
    // Deep-link into a panel, e.g. /external-leads/manage/:uuid/activity
    // (notification action_url).
    path: `${REACT_APP_NAV_ROUTES.leads.chatLeads}/manage/:uuid/:tab`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM]}>
        <ManageChatLead />
      </AuthorizedRoute>
    ),
  },
];
